/** Composante Header de Timtools */
export default class Simple_Header {
  /** La fonction pour le constructeur */
  constructor(element) {
    this.element = element;

    this.html = document.documentElement;

    this.init();
  }

  /**Fonction d'initialisation**/
  init() {
    this.hamburger = this.html.querySelector('.hamburger');
    this.hamburger.addEventListener('click', this.onClick.bind(this));

    //recupere la hauteur du header
    this.header = this.html.querySelector('header');

    //detecte si la grandeur de la fenetre change
    window.addEventListener("resize", this.changeHeaderHeight.bind(this));

    //detecte si la souris clique sur la fenetre
    window.addEventListener('click', this.onClickOutside.bind(this));

    //change la valeur top de la position absolute du nav
    this.headerHeight = this.header.offsetHeight;
    this.nav = this.html.querySelector('nav');
    this.nav.style.top = this.headerHeight + 'px';
  }

  onClick() {
    if (this.header.classList.contains('nav_mobile')) {
      window.removeEventListener('click', this.onClickOutside.bind(this));
      this.header.classList.remove('nav_mobile');
    } else {
      this.header.classList.add('nav_mobile');
    }
    
  }

  changeHeaderHeight(){
    this.headerHeight = this.header.offsetHeight;
    this.nav = this.html.querySelector('nav');
    this.nav.style.top = this.headerHeight + 'px';

    if(window.innerWidth > 768){

      window.removeEventListener('click', this.onClickOutside.bind(this));
      this.header.classList.remove('nav_mobile');
    }
  }

  onClickOutside(event) {
    this.targetElement = event.target;
    if (!this.targetElement.closest('header') && this.header.classList.contains("nav_mobile")) {
      window.removeEventListener('click', this.onClickOutside.bind(this));
      this.header.classList.remove('nav_mobile');
    }
  }
}
